 // Lightweight global AI context registry so the unified Assistant can
// understand the current screen/editor state without per-endpoint wiring.

export function getAiContext() {
  if (typeof window === "undefined") return null;
  return window.__VB_AI_CONTEXT__ || null;
}

export function setAiContext(next) {
  if (typeof window === "undefined") return;
  const prev = window.__VB_AI_CONTEXT__ || {};
  // Shallow merge; callers should provide full sub-objects as needed.
  window.__VB_AI_CONTEXT__ = { ...prev, ...(next || {}) };
}

// Separate registry for executable actions (functions) that the global AI sidebar can call.
// Keep it separate from context because context is often JSON-serialized.
export function getAiActions() {
  if (typeof window === "undefined") return null;
  return window.__VB_AI_ACTIONS__ || null;
}

export function setAiActions(next) {
  if (typeof window === "undefined") return;
  const prev = window.__VB_AI_ACTIONS__ || {};
  window.__VB_AI_ACTIONS__ = { ...prev, ...(next || {}) };
}

export function clearAiActions(keys) {
  if (typeof window === "undefined") return;
  if (!window.__VB_AI_ACTIONS__) return;
  if (!Array.isArray(keys) || !keys.length) {
    delete window.__VB_AI_ACTIONS__;
    return;
  }
  const next = { ...(window.__VB_AI_ACTIONS__ || {}) };
  keys.forEach((k) => {
    delete next[k];
  });
  window.__VB_AI_ACTIONS__ = next;
}

export function clearAiContext(keys) {
  if (typeof window === "undefined") return;
  if (!window.__VB_AI_CONTEXT__) return;
  if (!Array.isArray(keys) || !keys.length) {
    delete window.__VB_AI_CONTEXT__;
    return;
  }
  const next = { ...(window.__VB_AI_CONTEXT__ || {}) };
  keys.forEach((k) => {
    delete next[k];
  });
  window.__VB_AI_CONTEXT__ = next;
}

